import * as actions from '@actions';
import { useQuery } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import useUser from '@vl-core/hooks/useUser';

export function useMetaMisc() {
  const user = useUser();
  const dispatch = useDispatch();
  const result = useQuery({
    queryKey: ['meta/misc', user.user_guid],
    queryFn: () =>
      dispatch(actions.metaMisc()).then(({ meta: [data] }) => {
        const { langauges, timezones } = data;
        return {
          meta: [
            {
              ...data,
              languages: langauges.sort((lhs, rhs) => lhs.lang_desc.localeCompare(rhs.lang_desc)),
              timezones: timezones.sort()
            }
          ]
        };
      }),
    staleTime: Infinity,
    gcTime: Infinity,
    placeholderData: {
      meta: [
        {
          field_validators: null,
          filter_tags: null,
          timezones: [],
          info_tags: [],
          ireq_states: [],
          langauges: [],
          languages: [],
          geninv_states: [],
          file_types: []
        }
      ]
    }
  });
  return result.data?.meta[0]!;
}

export default useMetaMisc;
